// extracted by mini-css-extract-plugin
export var L = "singleimg-module--L--dbcd5";
export var M = "singleimg-module--M--9ca81";
export var S = "singleimg-module--S--dcafc";